import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import type { IFormElement } from '../types';
import { useFormState } from '../contexts/FormStateContext';
import styles from './fields.module.css';

export interface BooleanFieldProps {
  element: IFormElement;
  questionNumber?: number;
}

export const BooleanField: React.FC<BooleanFieldProps> = ({
  element,
  questionNumber,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const formState = useFormState();
  const error = errors[element.name];
  const validationError = formState.validationErrors[element.name];

  const labelTrue = element.labelTrue || 'Sim';
  const labelFalse = element.labelFalse || 'Não';

  const renderLabel = () => {
    if (!element.title) return null;
    return (
      <label
        className={`${styles.label} ${
          element.isRequired ? styles.required : ''
        }`}
      >
        {questionNumber && (
          <span className={styles.questionNumber}>{questionNumber}. </span>
        )}
        {element.title}
      </label>
    );
  };

  return (
    <div className={styles.formField}>
      {renderLabel()}
      {element.description && (
        <p className={styles.description}>{element.description}</p>
      )}
      <Controller
        name={element.name}
        control={control}
        defaultValue={element.defaultValue}
        render={({ field }) => (
          <div className={styles.booleanField}>
            <button
              type="button"
              className={`${styles.booleanOption} ${
                field.value === true ? styles.selected : ''
              }`}
              onClick={() => {
                field.onChange(true);
                formState.markFieldAsTouched(element.name);
                formState.clearValidationError(element.name);
              }}
              disabled={element.readOnly}
            >
              {labelTrue}
            </button>
            <button
              type="button"
              className={`${styles.booleanOption} ${
                field.value === false ? styles.selected : ''
              }`}
              onClick={() => {
                field.onChange(false);
                formState.markFieldAsTouched(element.name);
                formState.clearValidationError(element.name);
              }}
              disabled={element.readOnly}
            >
              {labelFalse}
            </button>
          </div>
        )}
      />
      {(error || validationError) && (
        <p className={styles.errorMessage}>
          {(error?.message as string) || validationError}
        </p>
      )}
    </div>
  );
};

export default BooleanField;
